<div
  class="crypto-select-container flex items-center gap-1 md:gap-2 text-base sm:text-base bg-white px-2 md:px-4 py-2 rounded-lg border border-gray-200 hover:border-gray-300 focus-within:border-blue-400 focus-within:ring-1 focus-within:ring-blue-400"
>
  <!-- Asset Icon -->
  @if (selectedCrypto) {
    <mat-icon
      [svgIcon]="selectedCrypto"
      [matTooltip]="selectedCrypto"
      aria-hidden="true"
      class="asset-icon flex-shrink-0"
      toggleMatTooltip
    >
    </mat-icon>
  }

  <!-- Asset Dropdown -->
  <select
    [(ngModel)]="selectedCrypto"
    (ngModelChange)="onSelectionChange($event)"
    [id]="inputId || 'crypto-select'"
    [attr.aria-label]="'Select cryptocurrency' | translate"
    class="asset-select !w-auto min-w-[4rem] bg-transparent outline-none cursor-pointer remove-default-input-style text-sm"
  >
    <!-- Fiat Currency Group -->
    @if (hasFiatCurrencies()) {
      <optgroup label="{{ 'PAYMENT_REPORT.fiat' | translate }}">
        @for (fiat of getFiatAssets(); track fiat.id) {
          <option [value]="fiat.assetTicker">{{ fiat.assetTicker }}</option>
        }
      </optgroup>
    }

    <!-- Crypto Assets Group -->
    @if (hasCryptoAssets()) {
      <optgroup label="{{ 'PAYMENT_REPORT.cryptoAssets' | translate }}">
        @for (crypto of getCryptoAssets(); track crypto.id) {
          <option [value]="crypto.assetTicker">{{ crypto.assetTicker }}</option>
        }
      </optgroup>
    }
  </select>
</div>
